import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

import CancelOrSave from '../cancel-or-save';
import * as S from './styles';

class Setting extends React.PureComponent {
  renderDefault() {
    const { t } = this.context;
    return (
      <div>
        {this.props.label}
        <S.Wrapper>
          <S.Value>{this.props.value}</S.Value>
          {this.props.editable && (
            <S.Link type="button" onClick={() => this.props.onStartEditing()}>
              {t('common', 'button.edit')}
            </S.Link>
          )}
        </S.Wrapper>
      </div>
    );
  }

  renderEditing() {
    const { t } = this.context;
    return (
      <div>
        {this.props.render(this.props)}
        <CancelOrSave
          showLoader={this.props.saving}
          onCancel={() => this.props.onCancel()}
          onSave={() => this.props.onSave()}
          saveButtonDisabled={this.props.saveButtonDisabled}
          cancelButtonText={t('common', 'button.cancel')}
          saveButtonText={t('common', 'button.save')}
        />
      </div>
    );
  }

  render() {
    return (
      <S.Setting>
        {this.props.editing ? this.renderEditing() : this.renderDefault()}
      </S.Setting>
    );
  }
}

Setting.propTypes = {
  loading: PropTypes.bool,
  editable: PropTypes.bool,
  editing: PropTypes.bool,
  saving: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  render: PropTypes.func.isRequired,
  onStartEditing: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saveButtonDisabled: PropTypes.bool,
};

Setting.defaultProps = {
  loading: false,
  editable: true,
  editing: false,
  saving: false,
  label: '',
  value: '',
  onStartEditing: () => {},
  saveButtonDisabled: false,
};

Setting.contextType = AppContext;

export default Setting;
